export default __webpack_public_path__ + "static/media/AtlantaTruck.12cd1731.jpg";